import {initTooltips} from "./V3/Services/Tooltip";
import customfn from "@/_functions.js";
import clp from "@/_clp.js";

$(function () {
    // If enter is hit in the form, check the status of the filled in tag
    $(document).on('keyup', 'form#centre_assign_tags_user .tag-input', function (ev){
        ev.preventDefault();
        var tag_number = $(this).val();
        var maxLength = (typeof $(this).attr('maxlength') != 'undefined') ? $(this).attr('maxlength') : 4;

        var el = $(this),
            number = el.index('form#centre_assign_tags_user');

        el.closest('form').find('.invalid-feedback').fadeOut("fast", function(){
            $(this).remove();
        });

        if((ev.which == 13 && tag_number.length > 0) || tag_number.length == maxLength)  {
            var url = $(this).data('user-assign-tag-url');

            // Check if the tag is in the assignment proces
            if(customfn.checkRegisteringTags(tag_number)){
                return false;
            }
            customfn.addRegisteringTags(tag_number);

            var formFields = [];
            formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
            formFields.push({name: "tag_number", value: $(document).find('input[name="tag_number"]').val()});
            formFields.push({name: "sync", value: $(document).find('input[name="sync"]').val()});

            customfn.postModal(url, formFields, {}, function(){
                var newEl = $('form#centre_assign_tags_user .tag-input:eq(' + number + ')');
                newEl.focus().click();

                // Remove the tag from the array
                customfn.removeRegisteringTags(tag_number);
            });
        }

        return false;
    })
    $(document).on('submit', 'form#centre_assign_tags_user', function (ev){
        ev.preventDefault();
        return false;
    });

    $(document).on('click', 'form#centre_assign_tags_user .save-assigned-buttons', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        customfn.postModal(url, $('form#assign_tag_number').serialize());
    })

    $(document).on('click', 'form#centre_assign_tags_user a.unassign-tag', function(ev){
        ev.preventDefault();

        customfn.unAssignTag($(this).closest('.assigned-tag'));
    });

    // Batch assign tags to users
    // If enter is hit in the form, check the status of the filled in tag
    $(document).on('keyup', 'form#general-manager-batch_assign_tags_user .tag-input', function (ev){
        ev.preventDefault();
        var tag_number = $(this).val();
        var maxLength = (typeof $(this).attr('maxlength') != 'undefined') ? $(this).attr('maxlength') : 4;

        $(this).closest('form').find('input').removeClass('is-invalid');
        $(this).closest('form').find('.invalid-feedback').hide();

        if((ev.which == 13 && tag_number.length > 0) || tag_number.length == maxLength)  {
            // Try to get the status of the tag
            customfn.registerBatchTag($(this));
        }

        return false;
    })

    $(document).on('submit', 'form#general-manager-batch_assign_tags_user', function (ev){
        ev.preventDefault();

        return false;
    });

    $(document).on('click', 'form#general-manager-batch_assign_tags_user a.user-batch-unassign-tag', function(ev){
        ev.preventDefault();

        customfn.unassignBatchTag($(this));
    });

    $(document).on('click', 'a.user-overview-block', function(ev){
        ev.preventDefault();

        var $ClickedButton = $(this);
        $ClickedButton.next('.spinner').show();
        $ClickedButton.hide();

        var typeAction = $(this).data('type-action');
        var url = $(this).attr('href');

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "action", value: typeAction});

        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            success : function(data){
                if(data.status &&
                    data.status == 1) {
                    var $userOverview = $(document).find('#company_team_employees');
                    var url = $userOverview.data('refresh-url');
                    if(typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $userOverview.html(data.html);
                                const tooltipTriggerList = Array.from($userOverview[0].querySelectorAll('[data-bs-toggle="tooltip"]'));
                                initTooltips(tooltipTriggerList);
                            }
                        })
                    }
                    var $tagOverview = $(document).find('#company_tags');
                    var url = $tagOverview.data('refresh-url');
                    if(typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $tagOverview.html(data.html);
                            }
                        })
                    }
                    var $tagsOverview = $(document).find('#centre-users-overview');
                    var url = $tagsOverview.data('refresh-url');
                    if(typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $tagsOverview.html(data.html);
                            }
                        })
                    }
                    var $usersOverview = $(document).find('#users-overview');
                    var url = $usersOverview.data('refresh-url');
                    if(typeof url != 'undefined') {
                        $.get(url, function (data) {
                            if (data.html) {
                                $usersOverview.html(data.html);
                            }
                        })
                    }
                }

                setTimeout(function(){
                    clp.refreshHardware($(document));
                }, 2000);

            },
            error : function(jqXHR){
                var data = jqXHR.responseJSON;
                $ClickedButton.next('.spinner').hide();
                $ClickedButton.show();
            }
        });
    });

    $(document).on('click', 'button.company-user-tags-update', function(ev){
        ev.preventDefault();
        $('input.tag-input').each(
            function () {
                $(this).focus().trigger(jQuery.Event('keyup', { keycode: 13, which: 13 }));
            }
        )
        var $accessMethodsOverview = $(document).find('#access-methods-overview');
        var url = $accessMethodsOverview.data('refresh-url');
        if(typeof url != 'undefined') {
            $.get(url, function (data) {
                if (data.html) {
                    $accessMethodsOverview.html(data.html);
                }
            })
        }

        // setTimeout(function(){
        //     clp.refreshHardware($(document));
        // }, 2000);

        //if($(this).data("dismiss") == 'modal'){
            customfn.hideModals();
        //}
    });

    var searchForms = $('#users-overview .search-form-mask, #centre-users-overview .search-form-mask, #centre-visitors-overview .search-form-mask');
    if(searchForms.length > 0) {
        searchForms.each(function(index, el){
            if($(el).hasClass('closed')) {
                $(el).addClass('open').removeClass('closed');
                $(el).find('.sb-search-input').click().focus();
            }
        });
    }


    $(document).on('click', '.js-access-remove-user', function (event) {
        event.preventDefault();
        const url = $(this).attr('href');
        customfn.getModal(url, $(this));
    });

    $(document).on('click', 'button.js-remove-user-confirm', function() {
        let formFields = [
            {name: "_token", value: $(document).find('input[name="_token"]').val()}
        ];

        // buttons
        var okButton = $(this);
        var cancelButton = okButton.prev('button');

        // Hide the cancel button
        cancelButton.hide();

        // Set the okButton to loading
        customfn.setButtonLoadingState(okButton);

        // Determine the url
        var url = okButton.attr('href');

        $.ajax(
            url,
            {
                data: $.param(formFields),
                method: 'POST',
                complete: function (jqXHR) {
                    if(jqXHR.responseJSON) {
                        var data = jqXHR.responseJSON;
                        if (data.html) {
                            customfn.showModal(data);
                        }
                    }
                }
            }
        )
    })

    /** Assign/Unassign nebula card */
    $(document).on('click', '.assign-card-user', function(ev){
        ev.preventDefault();
        customfn.getModal($(this).attr('href'));
    });

    $(document).on('click', 'button.company-user-card-update', function(ev){
        ev.preventDefault();

        $('input.card-input').each(
            function () {
                $(this).focus().trigger(jQuery.Event('keyup', { keycode: 13, which: 13 }));
            }
        )
        let $accessMethodsOverview = $(document).find('#access-methods-overview');
        let url = $accessMethodsOverview.data('refresh-url');

        if(typeof url != 'undefined') {
            $.get(url, function (data) {
                if (data.html) {
                    $accessMethodsOverview.html(data.html);
                    const tooltipTriggerList = Array.from($accessMethodsOverview[0].querySelectorAll('[data-bs-toggle="tooltip"]'));
                    initTooltips(tooltipTriggerList);
                }
            })
        }

        customfn.hideModals();
    });

    $(document).on('submit', 'form#centre_assign_card_user', function (ev){
        ev.preventDefault();
        return false;
    });

    $(document).on('keyup', 'form#centre_assign_card_user .card-input', function (ev){
        ev.preventDefault();
        let card_number = $(this).val();
        let maxLength = (typeof $(this).attr('maxlength') != 'undefined') ? $(this).attr('maxlength') : 14;

        let el = $(this), number = el.index('form#centre_assign_card_user');

        el.closest('form').find('.invalid-feedback').fadeOut("fast", function(){
            $(this).remove();
        });

        if ((ev.which === 13 && card_number.length > 0) || card_number.length === maxLength)  {
            let url = $(this).data('user-assign-card-url');
            let formFields = [];
            formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
            formFields.push({name: "card_number", value: $(document).find('input[name="card_number"]').val()});

            customfn.postModal(url, formFields, {}, function(){
                var newEl = $('form#centre_assign_card_user .card-input:eq(' + number + ')');
                newEl.focus().click();

                const invalidValues = document.getElementsByClassName('is-invalid');
                if (invalidValues.length === 0) {
                    customfn.refreshAccessMethodsOverview();
                }
            });
        }

        return false;
    })

    $(document).on('click', 'form#centre_assign_card_user a.unassign-card', function(ev){
        ev.preventDefault();
        customfn.unAssignTag($(this).closest('.assigned-tag'));
    });

    $(document).on('click', '.user-unassign-card', function(ev){
        ev.preventDefault();
        let url = $(this).attr('href');
        let formFields = [];
        let $row = $(this).closest('.assigned-tag');
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "card_number", value: $row.find('input.assigned_card').val()});
        customfn.postModal(url, formFields, {}, customfn.refreshAccessMethodsOverview);
    })

    document.addEventListener('click', function(e) {
        if (!e.target.matches('.js-show-xs4-com-ids-for-user')) {
            return;
        }

        e.preventDefault();
        const url = $(e.target).data('href');
        customfn.getModal(url, $(e.target));
    })
});
